const map = {
	"./admin.json": 467,
	"./auth.json": 94,
	"./automations.json": 208,
	"./canned.json": 397,
	"./claude.json": 330,
	"./common.json": 529,
	"./customers.json": 977,
	"./dashboard.json": 248,
	"./errors.json": 323,
	"./globalSearch.json": 699,
	"./layout.json": 934,
	"./mailbox.json": 804,
	"./meetings.json": 670,
	"./notifications.json": 912,
	"./portal.json": 318,
	"./profile.json": 405,
	"./projectCsv.json": 35,
	"./projectDetail.json": 176,
	"./projectTemplates.json": 156,
	"./projectView.json": 868,
	"./projects.json": 986,
	"./reports.json": 39,
	"./tickets.json": 589
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;